// Copyright (c) Microsoft Corporation.
// Licensed under the MIT License.

import type { OperationOptions } from "@azure-rest/core-client";

/** Optional parameters. */
export interface DatasetsGetCredentialsOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface DatasetsPendingUploadOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface DatasetsCreateOrUpdateOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface DatasetsDeleteOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface DatasetsGetOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface DatasetsListOptionalParams extends OperationOptions {}

/** Optional parameters. */
export interface DatasetsListVersionsOptionalParams extends OperationOptions {}
